export default __webpack_public_path__ + "static/media/clap.d2cd398f.svg";